export default "__VITE_ASSET__DFOjqcLJ__"